import React from "react";
import "./bookingWizard.css";

export default function Stepper({ steps = [], current = 0 }) {
  const total = Array.isArray(steps) ? steps.length : 0;
  const safeCurrent = Math.min(Math.max(current, 0), Math.max(total - 1, 0));
  const progress = total <= 1 ? 0 : Math.round((safeCurrent / (total - 1)) * 100);

  return (
    <div className="bw-stepper" aria-label="Progress">
      <div className="bw-stepperTrack">
        <div
          className="bw-stepperProgress"
          style={{ width: `${progress}%` }}
        />
      </div>

      <div
        className="bw-stepperNodes"
        style={{ gridTemplateColumns: `repeat(${total}, minmax(0, 1fr))` }}
      >
        {steps.map((label, i) => {
          const done = i < safeCurrent;
          const active = i === safeCurrent;

          return (
            <div key={i} className="bw-stepperNode">
              <div
                className={`bw-stepCircle ${done ? "isDone" : ""} ${active ? "isActive" : ""}`}
              >
                {i + 1}
              </div>
              <div className={`bw-stepLabel ${done || active ? "isOn" : ""}`}>
                {label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}